import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { OAuthService } from 'angular-oauth2-oidc';
import { ModuleAccessService } from './module-access.service';
import { ROOT_NAVIGATION } from '../../config/navigation.config';

export const moduleGuard: CanActivateFn = (route) => {
  const oauthService = inject(OAuthService);
  const router = inject(Router);
  const moduleAccessService = inject(ModuleAccessService);

  let redirectUrl = '/no-access';
  const hasIdToken = oauthService.hasValidIdToken();
  const hasAccessToken = oauthService.hasValidAccessToken();
  const hasAccessToModule = moduleAccessService.currentUserHasAccessTo(route.data.moduleType);

  if (hasIdToken && hasAccessToken && hasAccessToModule) {
    return true;
  }

  if (route.routeConfig?.path === '') {
    for (const page of ROOT_NAVIGATION) {
      if (page.path && moduleAccessService.currentUserHasAccessTo(page.module)) {
        redirectUrl = page.path;
        break;
      }
    }
  }

  return router.createUrlTree([redirectUrl]);
};
